import React from 'react'
import { Table } from 'semantic-ui-react'
import { BORDER_STYLE } from './SortableOrdersTable'
import {
  SORT_ORDER_ID,
  SORT_CUSTOMER_NAME,
  SORT_ORDER_TOTAL,
  SORT_ORDER_PAID,
  SORT_OVER_RETAIL,
  SORT_AI_INVOICE,
  SORT_CUSTOMER_BRAINTREE,
  SORT_TAX
} from '../../constants/search_filters'

// TODO: to get around a CSS issue of the table border extending too far, the <Table> was
// given no border and then styling added to individual cells.  This should be refactored.
export default function ReconciliationsTableHeader({sortableHeaderCell}) {
  const headerData = [
    { attr: SORT_ORDER_ID, label: 'ID' },
    { attr: SORT_CUSTOMER_NAME, label: 'Customer' },
    { attr: null, label: 'MM'},
    { attr: SORT_OVER_RETAIL, label: 'OR' },
    { attr: SORT_AI_INVOICE, label: 'AI/Inv Mismatch' },
    { attr: SORT_CUSTOMER_BRAINTREE, label: 'BT Mismatch' },
    { attr: SORT_TAX, label: 'Tax Mismatch' },
    { attr: SORT_ORDER_TOTAL, label: 'Total Price' },
    { attr: SORT_ORDER_PAID, label: 'Already Paid', borderRight: BORDER_STYLE }
  ]
  return(
    <Table.Row>
      {headerData.map((data, i) => sortableHeaderCell(data, i))}
    </Table.Row>
  )
}
